module.exports = __webpack_public_path__ + "img/balloon_task_full.9d8eb2f3.jpg";